import { action } from './util';
import { LocalStorageKey } from '../common/Definitions';

export const UserUIActionType = {
  SET_UI: 'SET_UI',
  UI_LOADED: 'UI_LOADED',
  LOADING_UI: 'LOADING_UI',
};

// Keys to access UI Config dictionary
export const UserUIKey = {
  WALL_FILTER_VALUE: 'WALL_FILTER_VALUE',
  WALL_SORT_DESC: 'WALL_SORT_DESC',
  WALL_SORT_VALUE: 'WALL_SORT_VALUE',
  WALL_HIDE_COMPLETED: 'WALL_HIDE_COMPLETED',
  WALL_OVERVIEW_INDEX: 'WALL_OVERVIEW_INDEX',
  GYM_MAP_FILTERS: 'GYM_MAP_FILTERS',
  GYM_MAP_SORT_DESC: 'GYM_MAP_SORT_DESC',
  GYM_MAP_SORT_VALUE: 'GYM_MAP_SORT_VALUE',
  GYM_MAP_HIDE_COMPLETED: 'GYM_MAP_HIDE_COMPLETED',
  GYM_MAP_OVERVIEW_INDEX: 'GYM_MAP_OVERVIEW_INDEX',
  GYM_SHOW_CIRCUIT_CUSTOM_CHART: 'GYM_SHOW_CIRCUIT_CUSTOM_CHART',
};

// Default UI Config
const defaultConfig = {};
defaultConfig[UserUIKey.WALL_FILTER_VALUE] = {};
defaultConfig[UserUIKey.WALL_SORT_DESC] = false;
defaultConfig[UserUIKey.WALL_SORT_VALUE] = null;
defaultConfig[UserUIKey.WALL_HIDE_COMPLETED] = false;
defaultConfig[UserUIKey.WALL_OVERVIEW_INDEX] = 0;
defaultConfig[UserUIKey.GYM_MAP_FILTERS] = {};
defaultConfig[UserUIKey.GYM_MAP_SORT_DESC] = false;
defaultConfig[UserUIKey.GYM_MAP_SORT_VALUE] = null;
defaultConfig[UserUIKey.GYM_MAP_HIDE_COMPLETED] = false;
defaultConfig[UserUIKey.GYM_MAP_OVERVIEW_INDEX] = 0;
defaultConfig[UserUIKey.GYM_SHOW_CIRCUIT_CUSTOM_CHART] = false;

// UI Config is based on Climb Type
const configStorageKey = (climb_type_id) => {
  return `${LocalStorageKey.USER_UI_CONFIG}_${[climb_type_id]}`;
};

export function getUI(climb_type_id) {
  const storageKey = configStorageKey(climb_type_id);

  return dispatch => {
    dispatch(loadingUI());
    let config = {};
    try {
      // Get existing config
      config = JSON.parse(localStorage.getItem(storageKey));
      if (!config) {
        config = defaultConfig;
        localStorage.setItem(storageKey, JSON.stringify(config));
      }
    } catch (err) {
      // Config may not exist; use and save default config
      localStorage.setItem(storageKey, JSON.stringify(defaultConfig));
      config = defaultConfig;
    }
    dispatch(uiLoaded(Object.assign({}, defaultConfig, config)));
  };
}

export function setUI(key, value, climb_type_id) {
  const storageKey = configStorageKey(climb_type_id);
  
  let config;
  try {
    // Save key-value for UI Config associated with climb type
    config = JSON.parse(localStorage.getItem(storageKey));
    config[key] = value;
    localStorage.setItem(storageKey, JSON.stringify(config));
  } catch (err) {
    // Config may not exist; use and save default config with new key-value
    config = defaultConfig;
    config[key] = value;
    localStorage.setItem(storageKey, JSON.stringify(config));
  }
  return action(UserUIActionType.SET_UI, { config: Object.assign({}, defaultConfig, config) });
}

export function loadingUI() {
  return action(UserUIActionType.LOADING_UI);
}

export function uiLoaded(config) {
  return action(UserUIActionType.UI_LOADED, { config });
}
